import React, { FC } from 'react';
import { Icon } from '../../Icon';
require("./ProductCardExtraLink.css");
var styles = {
  "Root": "ProductCardExtraLink-module-Root_32E",
  "Text": "ProductCardExtraLink-module-Text_48G",
  "Icon": "ProductCardExtraLink-module-Icon_2Cn"
};
export const ProductCardExtraLink = ({
  href,
  text,
  target
}) => {
  return /*#__PURE__*/React.createElement("a", {
    href: href,
    target: target,
    className: styles.Root
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.Text
  }, text), /*#__PURE__*/React.createElement(Icon, {
    name: "arrowForward",
    className: styles.Icon,
    size: "m"
  }));
};